import { paymentMethodSteps } from 'app/dealer/account/PaymentMethod/utils';

import {
  extractOpeningTimes,
  getNormalizedBranch,
  getNormalisedSepaMandate,
} from '../utils';

import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    branch: getNormalizedBranch({
      paymentMethod: 'sepa_direct_debit',
    }),
    branchCompleted: false,
    branchPending: false,
    dealerLoggedIn: true,
    error: null,
    paymentMethodStep: paymentMethodSteps.SEPA_MANDATE,
    phoneCheckPending: false,
    phoneValid: true,
    stage: 1,
    sepaMandate: getNormalisedSepaMandate({}),
    sepaMandateError: null,
    sepaMandatePending: false,
    sepaMandates: [],
    sepaMandatesError: null,
    sepaMandatesPending: false,
    sepaMandateTermsAccepted: false,
    shouldSetDefaultSepa: false,
    timesBlock: {
      saturdaysChecked: true,
      sundaysChecked: true,
    },
    tspList: [],
    tspPermission: false,
    zipCheckPending: false,
    zipValid: true,
    branchAgbData: {
      branchAgbFileName: '',
      branchAgbFileUrl: '',
      error: null,
      isHeycarAgb: true,
      isLoading: false,
    },
  };
};

export function branch(state = defaultState(), action) {
  const { type, payload, error } = action;

  if (type === ActionTypes.UPDATE_BRANCH) {
    const newBranch = {
      ...state.branch,
      ...payload,
    };

    return {
      ...state,
      branch: newBranch,
    };
  }

  if (type === ActionTypes.UPDATE_BRANCH_SEPA_MANDATE) {
    const newSepaMandate = {
      ...state.sepaMandate,
      ...payload,
    };

    return {
      ...state,
      sepaMandate: newSepaMandate,
    };
  }

  if (type === ActionTypes.RESET_BRANCH_SEPA_MANDATE) {
    return {
      ...state,
      paymentMethodStep: paymentMethodSteps.SEPA_MANDATE,
      sepaMandate: getNormalisedSepaMandate({}),
      sepaMandateTermsAccepted: false,
    };
  }

  if (type === ActionTypes.SET_BRANCH_PAYMENT_METHOD_STEP) {
    return {
      ...state,
      paymentMethodStep: payload,
    };
  }

  if (type === ActionTypes.UPDATE_BRANCH_SEPA_TERMS_ACCEPTED) {
    return {
      ...state,
      sepaMandateTermsAccepted: payload,
    };
  }

  if (type === ActionTypes.UPDATE_ALL_BRANCHES_SEPAS) {
    return {
      ...state,
      shouldSetDefaultSepa: payload,
    };
  }

  if (type === ActionTypes.UPDATE_OPENING_TIMES_BLOCK) {
    const newTimesBlock = {
      ...state.timesBlock,
      ...payload,
    };

    return {
      ...state,
      timesBlock: newTimesBlock,
    };
  }

  if (type === ActionTypes.UPDATE_TSP_PERMISSION) {
    return {
      ...state,
      tspPermission: payload,
    };
  }

  if (type === ActionTypes.UPDATE_SALES_BRANDS) {
    let { salesBrands } = state.branch;
    const { brandId, brandName } = payload;
    const exists = salesBrands.find(item => item.brandName === brandName);

    if (exists && !brandId) {
      salesBrands = salesBrands.filter(item => item.brandName !== brandName);
    } else if (exists && brandId) {
      const foundIndex = salesBrands.findIndex(item => {
        return item.brandName === brandName;
      });

      salesBrands[foundIndex] = payload;
    } else {
      salesBrands.push(payload);
    }

    const newBranch = {
      ...state.branch,
      salesBrands,
    };

    return {
      ...state,
      branch: newBranch,
    };
  }

  if (type === ActionTypes.FETCH_BRANCH_REQUEST) {
    return {
      ...state,
      branchPending: true,
    };
  }

  if (type === ActionTypes.FETCH_BRANCH_SUCCESS) {
    const { openingTimes } = payload;
    const newBranch = getNormalizedBranch(payload);
    const times = extractOpeningTimes(openingTimes);
    const newTimesBlock = {
      saturdaysChecked:
        times.saturday.from !== undefined && times.saturday.to !== undefined,
      sundaysChecked:
        times.sunday.from !== undefined && times.sunday.to !== undefined,
    };

    delete newBranch.openingTimes;
    newBranch.saturdayOpeningTimesFrom = times.saturday.from || '';
    newBranch.saturdayOpeningTimesTo = times.saturday.to || '';
    newBranch.sundayOpeningTimesFrom = times.sunday.from || '';
    newBranch.sundayOpeningTimesTo = times.sunday.to || '';
    newBranch.weekdayOpeningTimesFrom = times.weekDay.from || '';
    newBranch.weekdayOpeningTimesTo = times.weekDay.to || '';

    const branchAgbData = {
      branchAgbFileUrl: payload.termsAndConditionsLink
        ? payload.termsAndConditionsLink
        : '',
      isHeycarAgb: payload.termsAndConditionsLink ? false : true,
      isLoading: false,
      error: false,
    };

    return {
      ...state,
      branch: newBranch,
      branchCompleted: false,
      branchPending: false,
      error: null,
      isNew: false,
      timesBlock: newTimesBlock,
      tspPermission: true,
      branchAgbData,
    };
  }

  if (type === ActionTypes.FETCH_BRANCH_FAILURE) {
    const branchAgbData = {
      branchAgbFileUrl: '',
      isHeycarAgb: true,
      isLoading: false,
      error: false,
    };
    return {
      ...state,
      branch: getNormalizedBranch({}),
      branchPending: false,
      branchCompleted: false,
      tspPermission: false,
      error,
      branchAgbData,
    };
  }

  if (type === ActionTypes.FETCH_BRANCH_AGB_REQUEST) {
    return {
      ...state,
      branchAgbData: { isLoading: true },
    };
  }

  if (type === ActionTypes.FETCH_BRANCH_AGB_SUCCESS) {
    const dealerAgbData = payload.length ? payload[0] : [{ url: '' }];

    return {
      ...state,
      branchAgbData: {
        branchAgbFileName:
          dealerAgbData?.originalFileName ?? 'my-company-AGB.pdf',
        branchAgbFileUrl: dealerAgbData.url,
        isHeycarAgb: dealerAgbData.url === '' ? true : false,
        isLoading: false,
      },
    };
  }

  if (type === ActionTypes.FETCH_BRANCH_AGB_FAILURE) {
    return {
      ...state,
      branchAgbData: {
        error,
        isLoading: false,
      },
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_AGB_REQUEST) {
    return {
      ...state,
      branchAgbData: { isLoading: true },
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_AGB_SUCCESS) {
    const { url, originalFileName } = payload;

    return {
      ...state,
      branchAgbData: {
        branchAgbFileName: originalFileName ?? 'my-company-AGB.pdf',
        branchAgbFileUrl: url,
        isHeycarAgb: url === '' ? true : false,
        isLoading: false,
        error: false,
      },
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_AGB_FAILURE) {
    return {
      ...state,
      branchAgbData: {
        error,
        isLoading: false,
      },
    };
  }

  if (type === ActionTypes.USE_HEYCAR_AGB_REQUEST) {
    return {
      ...state,
      branchAgbData: { isLoading: true },
    };
  }

  if (type === ActionTypes.USE_HEYCAR_AGB_SUCCESS) {
    return {
      ...state,
      branchAgbData: {
        branchAgbFileName: '',
        branchAgbFileUrl: '',
        isHeycarAgb: true,
        isLoading: false,
        error: false,
      },
    };
  }

  if (type === ActionTypes.USE_HEYCAR_AGB_FAILURE) {
    return {
      ...state,
      branchAgbData: {
        error,
        isLoading: false,
      },
    };
  }

  if (type === ActionTypes.RESET_BRANCH) {
    return defaultState();
  }

  if (type === ActionTypes.SUBMIT_BRANCH_REQUEST) {
    return {
      ...state,
      branchPending: true,
      branchCompleted: false,
      error: null,
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_SUCCESS) {
    const { branch: currentBranch } = state;
    const { id } = payload;
    const newBranch = { ...currentBranch, id };

    return {
      ...state,
      branch: newBranch,
      branchCompleted: true,
      branchPending: false,
      error: null,
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_FAILURE) {
    return {
      ...state,
      branchCompleted: false,
      branchPending: false,
      error,
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_SEPA_MANDATE_REQUEST) {
    return {
      ...state,
      sepaMandateError: null,
      sepaMandatePending: true,
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_SEPA_MANDATE_SUCCESS) {
    const { id: sepaMandateId } = payload;
    const newBranch = {
      ...state.branch,
      sepaMandateId,
    };
    const sepaMandate = getNormalisedSepaMandate(payload);

    return {
      ...state,
      branch: newBranch,
      sepaMandate,
      sepaMandateError: null,
      sepaMandatePending: false,
    };
  }

  if (type === ActionTypes.SUBMIT_BRANCH_SEPA_MANDATE_FAILURE) {
    return {
      ...state,
      sepaMandateError: error,
      sepaMandateSubitted: false,
      sepaMandatePending: false,
    };
  }

  if (type === ActionTypes.GET_TSPLIST_SUCCESS) {
    const {
      _embedded: { tsps },
    } = payload;
    const tspList = tsps.filter(tsp => !tsp.hidden);

    return {
      ...state,
      tspList,
    };
  }

  if (type === ActionTypes.GET_TSPLIST_FAILURE) {
    return {
      ...state,
      error,
    };
  }

  if (type === ActionTypes.GET_SEPA_MANDATES_REQUEST) {
    return {
      ...state,
      sepaMandatesError: null,
      sepaMandatesPending: true,
    };
  }

  if (type === ActionTypes.GET_SEPA_MANDATES_SUCCESS) {
    const { sepaMandates } = payload;

    return {
      ...state,
      sepaMandates,
      sepaMandatesError: null,
      sepaMandatesPending: false,
    };
  }

  if (type === ActionTypes.GET_SEPA_MANDATES_FAILURE) {
    return {
      ...state,
      sepaMandates: [],
      sepaMandatesError: error,
      sepaMandatesPending: false,
    };
  }

  if (type === ActionTypes.CHECK_BRANCH_PHONE_REQUEST) {
    return {
      ...state,
      phoneValidPending: true,
    };
  }

  if (type === ActionTypes.CHECK_BRANCH_PHONE_SUCCESS) {
    return {
      ...state,
      phoneValidPending: false,
      phoneValid: true,
    };
  }

  if (type === ActionTypes.CHECK_BRANCH_PHONE_FAILURE) {
    return {
      ...state,
      phoneValidPending: false,
      phoneValid: false,
    };
  }

  if (type === ActionTypes.CHECK_BRANCH_ZIP_REQUEST) {
    return {
      ...state,
      zipValidPending: true,
    };
  }

  if (type === ActionTypes.CHECK_BRANCH_ZIP_SUCCESS) {
    return {
      ...state,
      zipValidPending: false,
      zipValid: true,
    };
  }

  if (type === ActionTypes.CHECK_BRANCH_ZIP_FAILURE) {
    return {
      ...state,
      zipValidPending: false,
      zipValid: false,
    };
  }

  return state;
}
